import { CONSTANTS } from '@/constants';
import { publicClient } from './client';
import { request } from './request';

const pollingInterval = 2 * 4e3;

async function fetchTransactionHash(transactionId: string) {
  try {
    const response = await request(
      `https://developer.worldcoin.org/api/v2/minikit/transaction/${transactionId}?app_id=${CONSTANTS.APP_ID}&type=transaction`,
      {
        method: 'GET',
      },
    );
    console.log('Received response:', response.url);
    if (!response.ok) {
      throw new Error('Failed to fetch transaction status');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log('Error fetching transaction status', error);
    throw new Error('Failed to fetch transaction status');
  }
}

export async function fetchStatus(
  transactionId: string,
): Promise<{ transactionHash: string }> {
  return await fetchTransactionHash(transactionId);
}

export async function waitForTransactionReceipt(
  transaction_id: string,
): Promise<string> {
  return new Promise((resolve, reject) => {
    const pollHash = async () => {
      try {
        const status = await fetchStatus(transaction_id);

        if (status.transactionHash) {
          const transaction = await publicClient.waitForTransactionReceipt({
            hash: status.transactionHash as `0x${string}`,
          });
          console.log('Transaction receipt:', transaction);
          resolve(transaction.transactionHash);
        } else {
          setTimeout(pollHash, pollingInterval);
        }
      } catch (error) {
        console.error('Error during polling:', error);
        reject(error);
      }
    };

    pollHash();
  });
}
